import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { post, patch, remove } from '../../services/api-services';
import { StyledButton, StyledCancelButton } from '../StyledComponent';
import { emailRegex, phoneNumberRegex, StringWithSpace } from '../../regex/regex';
import { useCommon } from '../../context/CommonContext';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton } from '@mui/material';
import DeleteDialog from '../../dialogs/DeleteDialog';
import { useNavigate } from 'react-router-dom';
export default function AddUser({ open, setOpen, onGetCases, userData, setUserData, userId,setUserId, paginationModel, search, selectedProgram,GetCases }) {
    const { setSnackbar, currentUser } = useCommon();
    const [openDelete, setOpenDelete] = React.useState(false)
    const navigate = useNavigate();
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserData({
            ...userData,
            [name]: value
        });
    };
    const isFormValid = userData.mobile && userData.name && userData.email && phoneNumberRegex?.test(userData?.mobile) && StringWithSpace?.test(userData?.name) && emailRegex?.test(userData?.email);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const capitalizeName = (name) => {
            return name
                .split(' ')
                .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
                .join(' ');
        };

        const capitalizedName = capitalizeName(userData?.name);

        const data = {
            name: capitalizedName,
            email: userData?.email,
            mobile: userData?.mobile,
            password: '123456',
            role: 'user',
            username: userData?.mobile,
            createdAt: new Date(),
            updatedAt: new Date(),
            status: 'active'
        };

        try {
            if (userId) {
                const response = await patch(`/Customers/${userId}`, data);
                if (response?.statusCode === 200) {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'User updated successfully!',
                        severity: 'success'
                    });
                    setOpen(false);
                    // Refresh cases list after update
                    await GetCases(currentUser, paginationModel, search, selectedProgram);
                }
            } else {
                const response = await post(`/Customers`, data);
                if (response?.statusCode === 200) {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'User registered successfully!',
                        severity: 'success'
                    });
                    setOpen(false);
                    // Refresh cases list FIRST, then navigate to details
                    await GetCases(currentUser, paginationModel, search, selectedProgram);
                    navigate(`/${currentUser?.role}/cases/caseDetails/${response?.data?.id}`);

                }else {
                    let errorMessage = response?.message || "Something went wrong!";
                
                    if (errorMessage.includes("Mobile number already exists")) {
                        errorMessage = "This mobile number is already registered. Please use a different one.";
                    } else if (errorMessage.includes("Email already exists")) {
                        errorMessage = "This email is already registered. Please choose another one.";
                    }
                
                    setSnackbar({
                        openSnackbar: true,
                        message: errorMessage,
                        severity: 'error'
                    });
                
                    setOpen(false);
                }
            }
            handleReset();
        } catch (error) {
            console.error('Error adding user:', error);
        }
    };


    const handleClose = () => {
        setOpen(false);
        handleReset();
    };

    // const handleDelete = async () => {
    //     try {
    
    //         setSnackbar({
    //             openSnackbar: true,
    //             message: 'User deleted successfully!',
    //             severity: 'success'
    //         })
    //         onGetCases(currentUser, paginationModel, search, selectedProgram);
    //         setOpenDelete(false);
    //         handleReset();
    //         setOpen(false);
    //     } catch (error) {
    //         console.error('Error deleting user:', error);
    //     }
    // };

    const handleDelete = async () => {
        try {
            // Delete all related data in parallel — use allSettled so partial failures don't block
            const relatedDeletions = await Promise.allSettled([
                remove(`/Customers/${userId}/supportTopics`),
                remove(`/Customers/${userId}/payments`),
                remove(`/Customers/${userId}/programs`),
                remove(`/Customers/${userId}/measurements`),
                remove(`/Customers/${userId}/galleries`),
            ]);

            // Check for any failures in related deletions
            const failures = relatedDeletions.filter(r => r.status === 'rejected');
            if (failures.length > 0) {
                console.warn('Some related data could not be deleted:', failures);
            }

            // Delete the user record last
            await remove(`/Customers/${userId}`);
        
            setSnackbar({
                openSnackbar: true,
                message: 'User deleted successfully!',
                severity: 'success'
            });
    
            onGetCases(currentUser, paginationModel, search, selectedProgram);

            setOpenDelete(false);
            handleReset();
            setOpen(false);
        } catch (error) {
            console.error('Error deleting user:', error);
            setSnackbar({
                openSnackbar: true,
                message: 'Failed to delete user. Please try again.',
                severity: 'error'
            });
        }
    };
    


    const handleReset = () => {
        setUserData({
            mobile: '',
            name: '',
            email: ''
        })
        setUserId(null);
    }
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                PaperProps={{
                    component: 'form',
                    onSubmit: handleSubmit,
                }}
            >
                <DialogTitle fontWeight='bold'>{userId ? 'Edit User' : 'Add User'}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="mobile"
                        name="mobile"
                        label="Mobile"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={userData?.mobile}
                        onChange={handleInputChange}
                        error={
                            userData?.mobile?.length > 0 && !phoneNumberRegex?.test(userData?.mobile)
                        }
                        helperText={
                            userData?.mobile?.length > 0 && !phoneNumberRegex?.test(userData?.mobile)
                                ? "Enter valid mobile no."
                                : ""
                        }
                    />
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="name"
                        name="name"
                        label="Name"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={userData.name}
                        onChange={handleInputChange}
                        error={userData?.name?.length > 0 && !StringWithSpace?.test(userData?.name)}
                        helperText={userData?.name?.length > 0 && !StringWithSpace?.test(userData?.name) ? "Enter valid name" : ""}
                        inputProps={{
                            maxLength: 50
                        }}
                    />
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="email"
                        name="email"
                        label="Email"
                        type="email"
                        fullWidth
                        variant="standard"
                        value={userData.email}
                        onChange={handleInputChange}
                        error={userData?.email?.length > 0 && !emailRegex?.test(userData?.email)}
                        helperText={userData?.email?.length > 0 && !emailRegex?.test(userData?.email) ? "Enter valid email" : ""}
                        
                    />
                </DialogContent>
                <DialogActions>
                  {userId &&  <Box display='flex' justifyItems='start' justifySelf='start'>
                        <IconButton size='small' onClick={() => setOpenDelete(true)} >
                            <DeleteIcon color="error" />
                        </IconButton>
                    </Box>}

                    <Box display='flex' gap={2}>
                        <StyledCancelButton variant='outlined' onClick={handleClose}>Cancel</StyledCancelButton>
                        <StyledButton variant="contained" type="submit" disabled={!isFormValid}>{userId ? 'Save' : 'ADD'}</StyledButton>
                    </Box>
                </DialogActions>
                <DeleteDialog
                    open={openDelete}
                    setOpen={setOpenDelete}
                    onSubmit={handleDelete}
                    name="User"
                />
            </Dialog>
        </React.Fragment>
    );
}
